import React from 'react';
import { INewsDetailsContentModel } from 'models/news-details-model';
import ContentRenderer from '../editorjs/editorjs-renderer';

import styles from './news-content.module.scss';

type Props = {
  content: INewsDetailsContentModel;
};

export default function NewsContent({ content }: Props) {
  if (!content) return <></>;

  return (
    <div className={styles.container}>
      <ContentRenderer content={content.content} />
    </div>
  );
}
